module.exports = __webpack_public_path__ + "img/current_location.png";